// extracted by mini-css-extract-plugin
export default {"imageContainer":"J0-z","summaryPar":"K0-z","ratingCategories":"L0-z","reviewerInfo":"M0-z","reviewTypes":"N0-z","expanded":"O0-z"};